module.exports = __webpack_public_path__ + "img/112ne.30ab94ba.svg";